import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const handoffSearchSchema = z.object({
  access_token: z.string().min(20).optional(),
  next: z.string().optional(),
})

/**
 * O bootstrap real roda em `main.tsx` (`applyAuthHandoffFromUrlIfNeeded`)
 * antes do router, para evitar corrida com guards de autenticação.
 */
export const Route = createFileRoute('/auth/handoff')({
  validateSearch: handoffSearchSchema,
  component: AuthHandoffFallback,
})

function AuthHandoffFallback() {
  return (
    <div className="flex min-h-svh items-center justify-center text-muted-foreground text-sm">
      Entrando no ImobDesk…
    </div>
  )
}
